import React, { SetStateAction, useCallback, useEffect, useState } from 'react'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../../types/interfaces'
import { mapOptions } from '../../../../utils/constants'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { useLocation } from 'react-router-dom'
import { getApi } from '../../../../../api/api'

export const useGMapForRoute = (
  data: SlotItemInterface | TransportItemInterface | CargoItemInterface,
  intercity: boolean,
  addresses?: boolean,
  setData?: React.Dispatch<
    SetStateAction<SlotItemInterface | CargoItemInterface | SlotItemInterface>
  >,
) => {
  const [gMap, setGMap] = useState<google.maps.Map | undefined>(undefined)
  const [renderer, setRenderer] = useState<google.maps.DirectionsRenderer | {}>({})
  const [service, setService] = useState<google.maps.DirectionsService | {}>({})
  const [directionsResponse, setDirectionsResponse] = useState<
    google.maps.DirectionsResult | null | undefined
  >(null)
  const darkTheme = useSelector(selectDarkTheme)
  const location = useLocation()
  const [api] = useState(getApi())

  function initMap(id: string, lat: number, lng: number) {
    const el = document.getElementById(id)
    if (el) {
      let map = new google.maps.Map(el, {
        zoom: 2,
        center: { lat: parseFloat(String(lat)), lng: parseFloat(String(lng)) }, // точка подачи и есть центр передавать в хук и в пропс
        ...mapOptions,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapId: '2ae8a6eb45821208',
        colorScheme: darkTheme ? 'DARK' : 'LIGHT',
      })
      setGMap(map)
    }
  }

  useEffect(() => {
    if (location.pathname.split('/')[2] === 'form') {
      data.route && directionRender(JSON.parse(data.route))
    }
    if (location.pathname.split('/')[2] === 'item') {
      getRoute()
    }
  }, [gMap])

  const getRoute = useCallback(async () => {
    try {
      if (data.routeId) {
        const result = await api.getRoute(data.routeId)
        setDirectionsResponse(JSON.parse(result.route))
      }
    } catch (error) {}
  }, [])

  async function directionRender(response: google.maps.DirectionsResult) {
    if (renderer instanceof google.maps.DirectionsRenderer) {
      await renderer.setOptions({
        suppressMarkers: false,
        directions: response,
        map: gMap,
        // draggable:true,
        // preserveViewport:false,
      })
      await renderer.setDirections(response)
    }
  }

  async function calculateRoute(field: 'city' | 'address') {
    if (
      !data.route &&
      data.points &&
      data.points.length > 1 &&
      !data.points.find((el) => !el[field].latitude) &&
      !data.points.find((el) => !el[field].longitude) &&
      gMap
    ) {
      const maxSequence = Math.max(...data.points.map((el) => el.sequence))
      if (
        data.points.find((el) => el.sequence === 1) &&
        data.points.find((el) => el.sequence === maxSequence) &&
        service instanceof google.maps.DirectionsService
      ) {
        let firstPoint = data.points.find((el) => el.sequence === 1)

        let lastPoint = data.points.find((el) => el.sequence === maxSequence)
        // let wayPointsArray: google.maps.DirectionsWaypoint[] = []

        let wayPointsArray: google.maps.DirectionsWaypoint[] = [
          ...data.points
            .filter((el) => el.sequence !== 1 && el.sequence !== maxSequence)
            .map((el) => {
              return {
                location: {
                  lat: el[field].latitude ? parseFloat(el[field].latitude.toString()) : 0,
                  lng: el[field].longitude ? parseFloat(el[field].longitude.toString()) : 0,
                },
              }
            }),
        ]

        const results = await service.route({
          origin: {
            location: {
              lat:
                firstPoint && firstPoint[field].latitude
                  ? parseFloat(firstPoint[field].latitude.toString())
                  : 0,
              lng:
                firstPoint && firstPoint[field].longitude
                  ? parseFloat(firstPoint[field].longitude.toString())
                  : 0,
            },
          },
          waypoints: wayPointsArray,
          destination: {
            location: {
              lat:
                lastPoint && lastPoint[field].latitude
                  ? parseFloat(lastPoint[field].latitude.toString())
                  : 0,
              lng:
                lastPoint && lastPoint[field].longitude
                  ? parseFloat(lastPoint[field].longitude.toString())
                  : 0,
            },
          },
          optimizeWaypoints: true,
          travelMode: google.maps.TravelMode.DRIVING,
        })

        setDirectionsResponse(results)
        setData && setData((prev) => ({ ...prev, route: JSON.stringify(results) }))

        //     let calculatedDistance = 0
        //     let calculatedDuration = 0

        //     calculateTime(results, 0, 0, 'calculate', pointFormData, setPointFormData)

        //     for (const leg of results.routes[0].legs) {
        //       calculatedDistance = calculatedDistance + leg.distance.value
        //       calculatedDuration = calculatedDuration + leg.duration.value
        //     }
        //     setRouteDistance(calculatedDistance)

        //     //set cost if...
        //     if (Adress.country.value === 'russia') {
        //       formData.cost.setValue(
        //         setCarriagePrice(CarriagePrice.prices, calculatedDistance, formData),
        //       )
        //       setRecommended(true)
        //     }

        //     setRouteDuration(calculatedDuration)
        //     formData.mileage = calculatedDistance
        //     setFormData({
        //       ...formData,
        //       direction_response: JSON.stringify(results),
        //     })

        //     setDirectionsResponse(results)
      }
      // setCalculate(false)
    }
  }

  useEffect(() => {
    setService(new google.maps.DirectionsService())
    setRenderer(new google.maps.DirectionsRenderer())
  }, [])

  useEffect(() => {
    initMap('map', 66.25, 94.15)
  }, [])

  useEffect(() => {
    if (location.pathname.split('/')[2] === 'form') {
          calculateRoute(intercity && !addresses ? 'city' : 'address')
    }
  }, [data.points, data.points?.length])

  useEffect(() => {
    directionsResponse && directionRender(directionsResponse)
  }, [directionsResponse])
}
